 <!--
 2019-2-13, AJK, added getters for login
 2019-2-26, AJK, added Application Generation nav
 2019-2-27, AJK, added Inquiry Generation nav
 -->


<template>
  <div class="navigation-component">
    <nav class="navbar is-fixed-top">
      <div class="navbar-brand">
        <div v-if="isLoggedIn" class="navbar-burger burger" data-target="main-nav" @click="toggleMenu" :class="{'is-active': navIsActive}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="main-nav" class="navbar-menu" :class="{'is-active': navIsActive}" >
        <div class="navbar-start">
          <router-link v-if="isLoggedIn" class="navbar-item"  @click.native="closeMenu" :to="{ name: 'dashboard' }">Order History</router-link>
          <router-link v-if="isLoggedIn" class="navbar-item"  @click.native="closeMenu" :to="{ name: 'orderRequest' }">New Order</router-link>
          <router-link v-if="isLoggedIn" class="navbar-item"  @click.native="closeMenu" :to="{ name: 'about' }">About Us</router-link>
        </div>
          <div class="navbar-header"><img src="../assets/images/deans-beans-logo_350x.webp" class="navbar-image"/></div>
        <div class="navbar-end">
          <router-link v-if="isLoggedIn" class="navbar-item"  @click.native="closeMenu" :to="{ name: 'userInfo', params: { recID: userInfo.recID} }"><b>My Account</b></router-link>
          <!-- <span v-if="isLoggedIn" class="navbar-item"></span> -->
          <router-link v-if="isLoggedIn" class="navbar-item"  @click.native="closeMenu" :to="{ name: 'cart' }"><b-icon icon="shopping-cart"></b-icon> &nbsp; Cart ( {{cart.products.length }} )</router-link>
          <!-- <router-link v-if="userInfo.isAdmin" class="navbar-item" @click.native="closeMenu" :to="{ name: 'users' }">Users</router-link> -->
          <template>            
            <router-link v-if="isLoggedIn"  class="navbar-item" :to="{ name: 'logout' }">Log out</router-link>
            <!-- <router-link  v-else class="navbar-item"  @click.native="closeMenu" :to="{ name: 'login' }">Login</router-link> -->
          </template>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { async } from 'q';

export default {
  name: 'NavigationComponent',
  data () {
    return {
      navIsActive: false
    }
  },
  computed:{
    ...mapGetters([
        'isLoggedIn', 'isPasswordChangeNeeded', 'isTokenExpired'
      ]),
    ...mapState([
      'userInfo', 'cart'
    ]),
    onLoginPage: function(){
      return this.$route.path == "/"
    }
  },
  methods: {
    toggleMenu: function () {
      this.navIsActive = !this.navIsActive
    },
    closeMenu: function () {
      this.navIsActive = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.navbar-image {
    max-width: 150px;
    margin: 0px 8px 0px 8px;
    height: auto;
    padding-top: .25rem;
}
.navbar-header {
  background-color: #fff;
}
.navbar-menu .is-active {
  background-color: #fff;
}
.navbar-menu{
//   box-shadow: 0 8px 16px rgba(10, 10, 10, .15)

    max-width: 1304px;
        flex-grow: 1;
    margin: 0 auto;
}
.navbar{
    border-bottom: 1px solid #e4e4e4;
}


@media only screen and (min-width: 414px) {
  .navbar-menu.is-active {
      display: block;
      padding: 0px;
  }
  .active{
    border-bottom: none ;
    color: #003F60;
  }
}
@media only screen and (min-width: 1088px) {
  .active{
    border-bottom: 5px solid #317D9B;
  }
}


</style>
